const AppConfig = {
  auth: {
    isLoggedIn: 'loggedInLottoIndexes',
    accessToken: 'accessTokenLottoIndexes',
    userRole: 'userRole'
  }
}

export default AppConfig;
